module.exports = __webpack_public_path__ + "assets/img/foshan.e7837a39.png";